import { useNavigate, useLocation } from "react-router-dom";

import { generate_queries, generate_item, update_stream, updateMetaTags, reversed, joinStream } from "../script.js";
import { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';

import Card from 'react-bootstrap/Card';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


export default function Vault(props) {
    const navigate = useNavigate();

    const [queries, setqueries] = useState([]);

    const urlParams = new URLSearchParams(useLocation().search);

    let stream_title = urlParams.get('title');
    let keywords = urlParams.get('keywords');

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip">
            {props}
        </Tooltip>
    );


    useEffect(() => {
        updateMetaTags();
        const loadingIndicator = document.getElementById('loading');
        const spinnerOverlay = document.getElementById('spinner-overlay');

        if (stream_title == null || stream_title == "" || keywords == null || keywords == "") {
            alert("Please enter a title and keywords to explore any topic instantly");
            navigate("/streams");
        }

        if (!props.loggedInEmail) {
            alert("You must be logged in to use this feature");
            // Redirect back to main
            navigate("/account");
        }

        document.getElementById("keyword-field").textContent = keywords;
        generate_queries(stream_title, keywords, loadingIndicator, spinnerOverlay).then((new_queries) => {
            document.getElementById("btn-generate").style.display = "flex";
            document.getElementById("btn-add").style.display = "flex";

            let querylist = [];
            for (let response in new_queries.responses) {
                querylist.push(new_queries.responses[response]);
            }
            setqueries(querylist);
        })
    }, []);

    async function addQuery(event) {
        let query = prompt("Enter query");
        if (query != null && query != "") {
            let updated_queries = queries.slice();
            updated_queries.push(query);
            setqueries(updated_queries);
        }
    }

    async function create_vault(title) {
        try {
            // Check if user is logged in
            var email = localStorage.getItem("useremail");

            const response = await fetch("https://sixhats-backend.onrender.com/stream", {
                method: "POST",
                body: JSON.stringify({
                    title: title,
                    by: "Automatic",
                    on: new Date().toLocaleString(),
                    at: "placeholder",
                    privacy: "public",
                    users: [],
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            });
            if (response.ok) {
                const responseData = await response.json();
                return responseData && responseData.guid;
            } else {
                console.log("Error getting response");
                return false;
            }
        } catch (error) {
            console.error('Error creating stream:', error);
            return false;
        }
    }

    async function generateStream(event) {
        const loadingIndicator = document.getElementById('loading');
        const spinnerOverlay = document.getElementById('spinner-overlay');

        if (window.confirm("Click 'ok' to generate stream. Please do not leave the page until stream generation is complete") == true) {
            loadingIndicator.textContent = "Loading... generating stream";
            let stream_id = await create_vault(stream_title);

            // TODO Fix backend such that user_list works
            let thingy = await joinStream(stream_id, props.loggedInEmail);
            console.log(thingy)
            // Iterate over table backward to preserve the given order
            for (let i in queries) {
                loadingIndicator.textContent = "Loading... Generating items (" + (parseInt(i) + 1) + "/" + queries.length + ")";
                let item_guid = await generate_item(queries[i], null, loadingIndicator, spinnerOverlay)
                update_stream(stream_id, item_guid, localStorage.getItem("useremail"));
            }
            // Redirect to streams
            navigate("/s/" + stream_id, { replace: true });
        }
    }

    return (
        <div className="content-div">
            <div className="stream-view">
                <h3 id="title-field">{stream_title} </h3>
                <p id="keyword-field">{keywords}</p>
                <hr style={{ height: "4px", width: "100%" }} />
                <div id="table_items" className="stream-table">
                    {queries.map((query, i) => {
                        return <Card>
                            <div className={'stream-table-row ' + (i % 2 != 0 ? 'dark-background' : '')}>
                                <div className="stream-table-left" onClick={() => {
                                    let updated_queries = queries.filter(s => s != query);
                                    setqueries(updated_queries);
                                }}>
                                    <FontAwesomeIcon icon={faX} ize="lg" />
                                </div>
                                <div className="stream-table-center">
                                    <h6>{query}</h6>
                                </div>
                            </div>
                        </Card>
                    })}
                </div>
                <p id="no_items" hidden> No items added to stream </p>
            </div>

            {/* <!-- Upward arrow button on the right side --> */}
            <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip("Add additional queries")}
            >
                <button className="fixed-button lower-mid-button" id="btn-add" style={{ display: "none" }} onClick={addQuery}>
                    <i className="fa-solid fa-pencil"></i>
                </button>
            </OverlayTrigger>

            <OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip("Explore any Topic instantly")}
            >
                <button className="fixed-button lower-button" id="btn-generate" style={{ display: "none" }} onClick={generateStream}>
                    <i className="fas fa-arrow-up"></i>
                </button>
            </OverlayTrigger>

            {/* <!-- Spinner overlay --> */}
            <div id="spinner-overlay" className="spinner-overlay" style={{ display: "none" }}>
                <i className="fas fa-spinner fa-spin fa-3x" style={{ color: "gray" }}></i>
                <span id="loading" className="center-screen-lower" style={{ display: "none", marginTop: "20px", backgroundColor: "white" }}>Loading...</span>
            </div>
        </div>
    );
}